import React from "react";

export const _h = React.createElement;
_h.Fragment = React.Fragment;
